// extracted by mini-css-extract-plugin
export var content = "_qa-1";
export var fullScreen = "_qa-0";